import Api from './base.api';

interface IDictionariesApi {
  fetch: (type: string) => Promise<any>,
  fetchByProject: (id: string) => Promise<any>,
  add: (params: { type: string, title: string, address: string }) => Promise<any>,
  delete: (id: string) => Promise<any>,
  edit: (params: any) => Promise<any>
}

class DictionariesApi extends Api implements IDictionariesApi {
  fetch = (type: string) => this.request(`institutions?type=${type}`);

  fetchByProject = (id: string) => this.request(`institutions?projectId=${id}`);

  add = (params: { type: string, title: string, address: string }) => this.request('institutions/add', {
    method: 'post',
    body: JSON.stringify(params)
  });

  delete = (id: string) => this.request(`institutions/${id}/remove`, {
    method: 'delete'
  });

  edit = (params: any) => this.request(`institutions/${params._id}/edit`, {
    method: 'post',
    body: JSON.stringify(params)
  });
}

export default new DictionariesApi();
